import { DEF_COORDS } from "../constants/Statics";
import axios from "../axios";

export const postApi_home = async ({
  coords: { lat, lng } = DEF_COORDS,
  propertyType = "A",
  page = 0,
  isFilter = 0,
  isSearch = 0,
}) => {
  const urlParams = new URLSearchParams();
  urlParams.append("lat", lat);
  urlParams.append("long", lng);
  urlParams.append("property_type", propertyType);
  urlParams.append("page", page);
  urlParams.append("is_filter", isFilter);
  urlParams.append("is_search", isSearch);

  const url = "/home?" + urlParams.toString();

  try {
    return (await axios.get(url)).data;
  } catch (err) {
    Promise.reject(err);
  }
};
